import { generatePath } from 'react-router-dom'
import { isAllowed } from 'src/utils'

class RouteError extends Error {
    constructor(msg) {
        super('RouteError: ' + msg)
    }
}

export const routeConfig = [
    {
        path: '/logout',
        title: 'Logout',
        component: './Logout',
        name: 'logout',
        breadcrumbs: [{ label: 'Logout' }],
    },
    {
        path: '/explorer/:entityName(device|event|configuration|customer|maintenance)/:maintenanceTimeframe(past|current|future)?',
        title: params => `Explorer ${params.entityName}`,
        component: './Explorer',
        name: 'explorer',
        breadcrumbs: [{ label: 'Dashboard' }],
        permissions: (context, pathname) => isAllowed(context, pathname),
    },
    {
        path: '/device/:deviceUID/:page(overview|events|tickets)',
        title: params => `${params.page}`,
        component: './DeviceDetail',
        name: 'device-detail',
        breadcrumbs: [{ label: 'Device overview' }],
    },
    {
        // This is a different route from device-detail as we need the pluginId, but it renders the same route.
        path: '/device/:deviceUID/:page(plugin)/:pluginUID',
        title: params => `${params.page}`,
        component: './DeviceDetail',
        name: 'device-plugin-detail',
        breadcrumbs: [{ label: 'Device overview' }],
    },
    {
        path: '/device/:deviceUID/:page(config|history)',
        title: params => `${params.page}`,
        component: './DeviceDetail',
        name: 'device-backup-detail',
        breadcrumbs: [{ label: 'Device overview' }],
    },
    {
        path: '/search-results',
        title: 'Search results',
        component: './Search',
        name: 'search-results',
        breadcrumbs: [{ label: 'Dashboard' }],
    },
    {
        path: '/my-filters',
        title: 'My filters',
        component: './MyFilters',
        name: 'my-filters',
        breadcrumbs: [{ label: 'Dashboard' }],
    },
    {
        path: '/my-exports',
        title: 'My exports',
        component: './MyExports',
        name: 'my-exports',
        breadcrumbs: [{ label: 'Dashboard' }],
    },
    {
        path: '/',
        title: `Home`,
        component: './Home',
        name: 'home',
        breadcrumbs: [{ label: 'Dashboard' }],
    },
]

export const reverse = (name, params = {}, queryParams = {}) => {
    const routes = routeConfig.filter(route => route.name === name)
    if (routes.length === 0) {
        throw new RouteError(`No matches found in routeConfig for ${name}`)
    } else if (routes.length > 1) {
        throw new RouteError(
            `Multiple matches found in routeConfig for ${name}: ${routes
                .map(r => r.path)
                .join(', ')}`
        )
    }
    // this will raise a TypeError if params provided do not match the path
    const path = generatePath(routes[0].path, params)
    if (Object.entries(queryParams).length) {
        const searchParams = new URLSearchParams(queryParams)
        return `${path}?${searchParams.toString()}`
    }
    return path
}
